import Button from './Button';
import Space from './Space';

const Intro = ({ setPageState }) => {
    return (
        <div className="content">
            <h1>Spiritual Depth Test</h1>
            <Space s={8} />
            <p>Sedalam apa kerohanianmu?</p>
            <Space s={40} />
            <p>
                Setiap orang menjalani kehidupan rohaninya dengan cara yang unik. Ada yang melihat iman sebagai pedoman
                moral, ada yang menjalin hubungan pribadi dengan Tuhan, dan ada juga yang menjadikan iman sebagai gaya
                hidup sehari-hari. Tes ini dirancang untuk membantumu memahami pendekatan spiritualmu saat ini—tanpa
                menghakimi, hanya untuk merefleksikan. Apakah kamu menjalani imanmu lebih sebagai tradisi, hubungan,
                atau cara hidup? Isi tes ini dan temukan di mana kamu berada dalam perjalanan rohanimu!
            </p>
            <Space s={40} />
            <Button onClick={() => setPageState('quiz')} label="START TEST" />
        </div>
    );
};

export default Intro;
